module.exports = require("jsrender/jsrender");